import {BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO } from '../../actions/types'

const initialState = undefined;

export default function reducerAgrupadosDisponibilidadesVeiculo (state = [], action = initialState) {
  switch (action.type) {
    case BUSCAR_AGRUPADOS_DISPONIBILIDADES_VEICULO: {
      const agrupadodisponibilidadeVeiculo = action.payload.data;

      if (agrupadodisponibilidadeVeiculo) {
        return agrupadodisponibilidadeVeiculo.sort((a, b) => a.veiculo.id - b.veiculo.id)
      }
      return []
    }

    default: {
      return state
    }
  }
}
